import { forwardRef, HTMLProps, LegacyRef } from 'react';
import cx from 'classnames';

import styles from './Text.module.scss';

export type TextSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
export type TextWeight = 'bold';
export type TextColor = 'white' | 'red';
export type TextAs = 'div' | 'span';

export type TextProps = Pick<HTMLProps<HTMLDivElement>, 'className' | 'children'> & {
  size?: TextSize;
  weight?: TextWeight;
  color?: TextColor;
  as?: TextAs;
  underline?: boolean;
};

const Text = forwardRef<HTMLElement | HTMLSpanElement, TextProps>(
  ({ children, className, size, weight, color = 'white', underline = false, as: As = 'div', ...htmlProps }, ref) => (
    <As
      ref={ref as LegacyRef<HTMLDivElement>}
      className={cx(className, styles.container, {
        [styles[`size--${size}`]]: size,
        [styles[`weight--${weight}`]]: weight,
        [styles[`color--${color}`]]: color,
        [styles.underline]: underline
      })}
      {...htmlProps}
    >
      {children}
    </As>
  )
);

export default Text;
